import { SmsService } from '../../../../../../api/src/lib/sms/sms.service';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  EventEmitter,
  Input,
  Output,
  ChangeDetectorRef,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  AppErrors,
  ErrorMsgComponent,
} from '@fitness-force/errors';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';

import { BehaviorSubject, Observable } from 'rxjs';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { TENANTSINTERFACE } from '@fitness-force/models';
import { FileUploadModule } from 'primeng/fileupload';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { EditorModule } from 'primeng/editor';
import { MessageModule } from 'primeng/message';

import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { ToastMessageService } from '@fitness-force/api';

@Component({
  selector: 'create-sms',
  templateUrl: './create-sms.component.html',
  styleUrls: ['./create-sms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    SelectModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    AvatarModule,
    ButtonModule,
    BlockUIModule,
    StyleClassModule,
    InputTextModule,
    PasswordModule,
    FileUploadModule,
    ToggleSwitchModule,
    EditorModule,
    MessageModule,
    ShortNamePipe,
    ErrorMsgComponent,
    TranslateModule,
    RippleModule
  ]
})
export class CreateSmsComponent implements OnInit {
  @Input() createSmsModal: boolean | null = false;
  @Input() clientData$ = new BehaviorSubject(null);
  @Output() closeCreateSmsDialog = new EventEmitter();

  smsFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  attachments: any;
  selectedAttachment: { name: string } | undefined;
  editorText: string | undefined;
  allClientData$ = new BehaviorSubject<any>([]);
  getAccessTenantList$: Observable<TENANTSINTERFACE>;
  selectedtenant: any;
  clientData: any;
  allSmsTemplates$ = new BehaviorSubject<any>([]);
  sendMessageDefaultState: boolean = true;
  sendMobileNotification: boolean = false;
  sendWhatsApp: boolean = false;
  sendSMS: boolean = false;

  btnLoading: boolean = false;

  constructor(
    private store: Store,
    private smsService: SmsService,
    public translate: TranslateService,
    private fb: UntypedFormBuilder,
    private toastMessageService: ToastMessageService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.componentInit();
  }

  ngAfterViewInit() {
    const imgButton = document.getElementsByClassName('ql-image');
    for (let i = 0; i < imgButton.length; i++) {
      imgButton[i].remove();
    }
  }

  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.selectedtenant = tenant.selected_tenant;
    });
    this.clientData$.subscribe((client: any) => {
      this.clientData = client;
      this.allClientData$.next(client);
    });

    this.smsFormGroup = this.fb.group({
      content: ['', [Validators.required]],
      is_marketing_msg:[false]
    });
  }

  get ContentFormControl(): UntypedFormControl {
    return this.smsFormGroup.get('content') as UntypedFormControl;
  }

  get IsMarketingMsgFormControl():UntypedFormControl
  {
    return this.smsFormGroup.get('is_marketing_msg') as UntypedFormControl;
  }

  closeDialogEvent() {
    this.smsFormGroup.reset();
    this.sendMessageDefaultState = true;
    this.sendMobileNotification = false;
    this.sendWhatsApp = false;
    this.sendSMS = false;
    this.closeCreateSmsDialog.emit(false);
  }

  SendMessage() {
    if (this.smsFormGroup.valid) {
      let requestPayload: any;
      let request: any
      if (this.sendWhatsApp) {
        requestPayload = {
          to_phone_number: this.clientData.mobile_country_code + this.clientData.mobile_number,
          content: this.ContentFormControl.value,
        };
        request = this.smsService.SendWhatsAppMessage(this.selectedtenant.id, this.clientData.id, requestPayload)
      }

      request.subscribe({
        next: (res: any) => {
          this.translate.get('SMS.SMS_MSG_INFO').subscribe((translation) => {
            this.toastMessageService.showError(translation);
          });
          this.btnLoading = false;
        },
        error: (error: AppErrors) => {
          this.btnLoading = false;
          this.toastMessageService.showError(error);
          this.cd.detectChanges();
        }
      });
    }
    else {
      Object.keys(this.smsFormGroup.controls).forEach((field) => {
        const control = this.smsFormGroup.get(field);
        control?.markAsDirty({ onlySelf: true });
      });
    }
    this.cd.detectChanges();
  }

  toggleSendMsgContent() {
    this.smsFormGroup.reset();
    this.sendMessageDefaultState = false;
    this.sendSMS = false;
    this.sendWhatsApp = false;
    this.sendMobileNotification = false;
  }

  IsClientPermission()
  {
     if(this.sendSMS) return this.clientData.promotional_sms;
     else if(this.sendWhatsApp) return this.clientData.promotional_whatsapp;
     else true;
  }

}
